import React, { useState, useCallback, useEffect } from 'react'
import EstateList from './components/estate/estateList'
import './components/sass/style.css'
import Container from 'react-bootstrap/Container'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import Modal from 'react-bootstrap/Modal'
import EstateAdd from './components/estate/estateAdd'
import EstateCardDetails from './components/estate/estateCardDetails'
import EstateUpdate from './components/estate/estateUpdate'
import Cookies from 'universal-cookie'
import Login from './components/login/login'
import {
  BrowserRouter,
  Switch,
  Route
} from "react-router-dom";
import Forgotten from './components/login/forgotten'
import Dropdown from 'react-bootstrap/Dropdown'
import PasswordChange from './components/account/passwordChange'
import Axios from 'axios'

// Cookies yum yum
const cookies = new Cookies()

// Api Key and Api URL
const api_key = cookies.get('dataUser')
const base_url = "https://plantsite.com/listings/" // Modify base_url according to the endpoint root folder on Plantsite

// HomeSite Hostname
const homesite = "homesite.com.mx"// Modifiy according to the Homesite's hostname (window.location.hostname)

// PlantSite Hostname
const plantsite = "plantsite.com"// Modify according to the PlantSite's hostname (window.location.hostname)

function App() {

  //States
  const [controlPanel, setControlPanel] = useState(false)
  const [modal, modalShow] = useState(false)
  const [modalContent, setModalContent] = useState({ createEstate: false, updateEstate: false, passwordChange: false })
  const [cardDetailsShow, setCardDetailsShow] = useState(false)
  const [cardDetailsData, setCardDetailsData] = useState([])
  const [cardList, setCardList] = useState([])

  //Modal handlers
  const handleClose = () => modalShow(false)
  const handleShow = () => modalShow(true)

  const closeModal = useCallback(
    () => {
      handleClose()
    }, [])

  //Update and create Handlers
  const updateEstate = useCallback(
    (data) => {
      setModalContent({ updateEstate: true })
      setCardDetailsData(data)
      handleShow()
    }, [])

  const createEstate = () => {
    setModalContent({ createEstate: true })
    handleShow()
  }

  //Open and close card details Handlers
  const closeCardDetails = useCallback(
    () => {
      document.getElementById("main-container").hidden = false
      setCardDetailsShow(false)
      setCardDetailsData([])
    }, []
  )

  const viewEstateDetails = useCallback(
    (data) => {
      document.getElementById("main-container").hidden = true
      window.scrollTo(0, 0)
      setCardDetailsShow(true)
      setCardDetailsData(data)
    }, []
  )

  //Logout and control panel visibility
  const logOut = () => {
    cookies.remove('dataUser', { path: '/' })
    cookies.remove('email', { path: '/' })
    cookies.remove('user_name', { path: '/' })
    cookies.remove('user_id', { path: '/' })
    window.location.href = '/paneldecontrol'
  }

  const ConfirmControlPanel = () => {
    cookies.get('dataUser') && setControlPanel(true)
  }

  //Card List Fetch
  const FetchCardsList = () => {
    Axios.post(base_url + "endpoint/estate", { operation: "read_estate_list", api_key: api_key })
      .then(res => {
        setCardList(res.data)
      })
  }

  //Effects
  useEffect(() => {
    ConfirmControlPanel()
  }, [])

  useEffect(() => {
    FetchCardsList()
  }, [])

  useEffect(() => {
    FetchCardsList()
  }, [modal])

  //Callbacks
  const FetchList = useCallback(() => {
    FetchCardsList()
  }, [])
  return (
    <BrowserRouter basename='/listings_test'>
      <Switch>
        <Route path="/paneldecontrol" >
          <Login base_url={base_url} />
        </Route>
        <Route path="/forgotten">
          <Forgotten base_url={base_url} />
        </Route>
        <Route path="/" exact>
          {controlPanel &&
            <>
              {/*Add estate icon*/}
              < Fab className="plus-btn" color="primary" aria-label="add" id="add-button" onClick={createEstate}><AddIcon /></Fab>

              {/*Add estate modal*/}
              <Modal show={modal} onHide={handleClose} size={modalContent.createEstate | modalContent.updateEstate && 'lg'}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {modalContent.passwordChange && <>Cambiar contraseña</>}
                    {modalContent.createEstate && <>Agregar propiedad</>}
                    {modalContent.updateEstate && <>Actualizar propiedad </>}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {modalContent.passwordChange && <PasswordChange base_url={base_url} api_key={api_key} />}
                  {modalContent.createEstate && <EstateAdd api_key={api_key} closeModal={() => closeModal()} base_url={base_url} />}
                  {modalContent.updateEstate && <EstateUpdate api_key={api_key} closeModal={() => closeModal()} base_url={base_url} data={cardDetailsData} />}
                </Modal.Body>
              </Modal>
            </>
          }
          {/*View all details*/}
          {cardDetailsShow &&
            <EstateCardDetails
              data={cardDetailsData}
              closeCardDetails={() => closeCardDetails()}
              base_url={base_url}
              controlPanel={controlPanel}
              api_key={api_key}
              homesite={homesite}
              plantsite={plantsite}
            />}

          {/*Main container and estates list*/}
          <Container id="main-container">
            {controlPanel && window.location.hostname === homesite &&
              <div style={{ textAlign: 'right' }}>
                <Dropdown>
                  <Dropdown.Toggle style={{ background: 'none', color: 'black', border: 'none' }} id="dropdown-basic">
                    {cookies.get('user_name')}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => { modalShow(true); setModalContent({ passwordChange: true }) }}>Cambiar contraseña</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <div>
                  <button className="btn btn-sm btn-secondary" onClick={logOut}>Cerrar Sesión</button>
                </div>
              </div>
            }

            <EstateList
              api_key={api_key}
              base_url={base_url}
              cardList={cardList}
              updateEstate={updateEstate}
              viewEstateDetails={viewEstateDetails}
              editable={controlPanel}
              FetchList={FetchList}
            />
          </Container>
        </Route>

      </Switch>
    </BrowserRouter>
  );
}

export default App;
